import React from "react";

export interface ChangeFractionProps {
  changeFraction: number | null;
  isPositiveChangeGood: boolean;
  muted?: boolean;
}

export default function ChangeFractionDisplay({
  isPositiveChangeGood,
  changeFraction,
  muted,
}: ChangeFractionProps) {
  let className = "";
  let value = "—%";

  if (
    typeof changeFraction !== "undefined" &&
    changeFraction !== null &&
    !isNaN(changeFraction)
  ) {
    const positiveChange = changeFraction >= 0;

    if (positiveChange) {
      className = isPositiveChangeGood ? "text-good" : "text-bad";
    } else {
      className = isPositiveChangeGood ? "text-bad" : "text-good";
    }

    value = `${
      Math.abs(changeFraction) >= 1e12
        ? "∞"
        : (Math.abs(changeFraction) * 100).toFixed(1)
    }%`;

    if (!positiveChange) {
      value = `−${value}`;
    }
  }

  if (muted) {
    className = `${className} muted`;
  }

  return <small className={className}>{value}</small>;
}
